<template>
	<section id="files-card">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<template v-if="filesStates !== null">
			<b-row>
				<b-col
					cols="4"
					v-for="fileData in singleFiles"
					:key="fileData.key"
				>
					<b-card class="mb-2 logo text-center" :title="fileData.label">
						<div class="box-image">
							<img v-if="fileData.file.type === 'image/png' || fileData.file.type === 'image/jpg' || fileData.file.type === 'image/jpeg'" :src="fileData.file.url"/>
							<md-icon v-else icon="description"/>
							<b-button v-if="!unableEdit && !unableDelete" class="delete-image" @click="() => confirmDelete(fileData.file.id)" variant="danger" size="sm"><md-icon icon="delete"/></b-button>
							<b-button class="download-image" :href="fileData.file.url" download variant="warning" target="_blank" size="sm"><md-icon icon="get_app"/></b-button>
						</div>
						<b-card-body v-if="!unableEdit">
							<div v-if="fileData.update" class="mt-3">
								<b-form-file
									v-model="fileData.input"
									:state="Boolean(fileData.input)"
									@input="newImageUpload(fileData,$event)"
									drop-placeholder="Drop file here..."
									class="mb-4"
								></b-form-file>
								<Cropper
									v-model="fileData.cropperDialog"
									:src="fileData.cropperSrc"
									:aspectRatio="fileData.aspectRatio"
									@crop="fileData.input = $event" />
								<b-button @click="fileData.update = false" variant="warning">Cancelar</b-button>
								<b-button @click="() => updateFile(fileData)" variant="primary" v-if="isValidFile">Subir</b-button>
							</div>
							<b-button v-else @click="fileData.update = true" variant="warning">Cambiar</b-button>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>

			<!----COLECTION FILES------>
			<b-card
				:title="fileData.label"
				v-for="fileData in collectionFiles"
				:key="fileData.key"
				class="mb-2"
			>
				<b-row v-if="fileData.files.length>0">
					<b-col
						cols="3"
						v-for="(file,i) in fileData.files"
						:key="i"
					>
						<div class="box-image">
							<img v-if="file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'" :src="file.url"/>
							<md-icon v-else icon="description"/>
							<b-button v-if="!unableEdit && !unableDelete" class="delete-image" @click="() => confirmDelete(file.id)" variant="danger" size="sm"><md-icon icon="delete"/></b-button>
							<b-button class="download-image" :href="file.url" download variant="warning" target="_blank" size="sm"><md-icon icon="get_app"/></b-button>
						</div>
					</b-col>
				</b-row>
				<p v-else>No se ha cargado imagenes</p>
				<hr>
				<b-row class="mt-4" align-h="between" v-if="!unableEdit">
					<p class="text-info">Peso máximo de la imagen: 1MB. Dimensiones máximas 1024x768</p>
					<div v-if="errorMessages.length" class="text-danger w-100 pb-2">
						<div v-for="(error, index) in errorMessages" :key="index">{{ error }}</div>
					</div>
					<b-col cols="8">
						<b-form-file
							class="input-file"
							v-model="fileData.input"
							@input="newImageUpload(fileData,$event)"
							:state="Boolean(fileData.input)"
							drop-placeholder="Drop file here..."
							placeholder="Seleccione o arrastrelo(s) aqui..."
							multiple
						/>
						<Cropper
							v-model="fileData.cropperDialog"
							:src="fileData.cropperSrc"
							:aspectRatio="fileData.aspectRatio"
							@crop="fileData.input = $event" />
					</b-col>
					<b-col cols="4" class="text-right" v-if="isValidFile">
						<b-button v-if="!fileData.loading" @click="() => uploadMultiFiles(fileData)" variant="primary">Agregar</b-button>
						<b-spinner v-else small />
					</b-col>
				</b-row>
			</b-card>
		</template>
		<template></template>
	</section>
</template>

<script>
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'
import Cropper from "@/components/helpers/Cropper";

export default {
	props : {
		modelId : {
			type: Number,
			required: true,
		},
		modelReference : {
			type: String,
			required: true,
		},
		fileKeys : {
			type: Array,
			required: true,
		},
		counter : {
			type: Array,
			required: false,
		},
		unableEdit : {
			type: Boolean,
			default: false,
		},
		unableDelete : {
			type: Boolean,
			default: false,
		},
		validations: {
			type: Object,
			required: false,
			default: null
		}
	},
	components: {
		Cropper
	},
	data(){
		// const translatableValues = {}
		return {
			loading:true,
			cropperDialog: false,
			cropperSrc: null,
			filesStates : null,
			errorMessages: [],
			validCount: 0
		}
	},
	computed : {
		singleFiles(){
			return this.filesStates !== null ? this.filesStates.filter(fileState => fileState.type === 'single') : []
		},
		collectionFiles(){
			return this.filesStates !== null ? this.filesStates.filter(fileState => fileState.type === 'collection') : []
		},
		countFiles(){
			return this.filesStates !== null ? this.filesStates.map(fileState => ({
				key:fileState.key,
				count:fileState.type === 'single' ? (fileState.id > 0 ? 1 : 0) : fileState.files.length,
			})) : []
		},
		isValidFile() {
			if (this.errorMessages.length > 0) {
				return false
			}

			return true;
		}
	},
	methods:{
		confirmDelete(fileId) {
			this.$bvModal.msgBoxConfirm('¿Esta seguro que desea eliminar este archivo?', {
				title: 'Confirmación eliminación archivo.',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'SI, Eliminar!',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false
			})
			.then(value => {
				if(value) this.deleteFile(fileId)
			})
			.catch(err => {
				console.log(err)
			})
		},
		deleteFile(fileId){
			this.loading = true
			this.$root.api.delete(
				`files/${this.modelReference}/${this.modelId}/${fileId}`,
			).then(() => {
				this.$root.showAlert('Archivo eliminado')
				this.loadFiles();
			}).catch(this.$root.handleRequestError);
		},
		updateFile(fileState){
			if (fileState.input === null) {
				this.$root.showAlert('No has seleccionado una imagen',{variant:'danger'})
				return
			}
			this.loading = true
			this.uploadFileToServer(fileState)
			.then(()=>{
				this.loadFiles();
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				fileState.input = null;
				this.loading = false
			});

		},
		initFilesStates(){
			this.filesStates = this.fileKeys.map(fileKey => ({
				cropperDialog: false,
				cropperSrc: null,
				cropper: fileKey.cropper,
				aspectRatio: fileKey.aspectRatio,
				key:fileKey.keyName,
				loading:false,
				input:null,
				update:false,
				type: fileKey.keyName.indexOf('[]') === -1 ? 'single' : 'collection',
				file:{id:-1,url:'',type:''},
				files:[],
				label:fileKey.label,
			}))
		},
		loadFiles(){
			this.loading = true;
			this.$root.api.get(`files/${this.modelReference}/${this.modelId}`).then((res) => {
				this.filesStates.forEach( fileState => {
					const aux = res.data.find(fileData => fileData.keyName === fileState.key)
					if (aux !== undefined) {
						if (fileState.type === 'single') {
							fileState.file = {id:aux.file.id, url:aux.file.url, type: aux.file.type}
						}else{
							fileState.files = aux.files.map(fileData => ({id:fileData.id, url: fileData.url, type: fileData.type}))
						}
					}
				})
			})
			.catch(this.$root.handleRequestError)
			.then(() => {
				this.loading = false;
			});
		},
		newImageUpload(fileData,e){
			//podemos validar las imagenes antes de subirlas
			const files = fileData.input
			this.errorMessages = []
			files.forEach((element, index) => {
				this.validateFile(element, index);
			});

			if(fileData.cropper && e){
				fileData.cropperDialog = true;
				fileData.cropperSrc = URL.createObjectURL(e)
			}
		},
		uploadMultiFiles(fileState){
			if (fileState.input === null) {
				this.$root.showAlert('No has seleccionado una imagen',{variant:'danger'})
				return
			}
			if(fileState.input.length>10){
				this.$root.showAlert("El Maximo de archivos para subir por batch son 10")
				return;
			}
			let _fileState         = {...fileState};
			let totalFilesUploaded = 0;
			let totalFiles = fileState.input.length;
			this.loading   = true
			fileState.input.forEach((file)=>{
				_fileState.input = file;
				this.uploadFileToServer(_fileState)
				.then(()=>{
					if(++totalFilesUploaded == totalFiles){
						this.$root.showAlert('Todos los archivos han sido cargado con exito')
					}
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					totalFiles--;
					if(totalFiles<=0){
						fileState.input = null;
						this.loading = false
						this.loadFiles();
					}
				})
			})
		},
		uploadFileToServer(fileState){
			let formData = new FormData();
			formData.append('file',fileState.input)
			formData.append('keyName',fileState.key)
			return new Promise((resolve,reject)=>{
				this.$root.api.post(`files/${this.modelReference}/${this.modelId}`,formData,{ headers:{'Content-Type': 'multipart/form-data'}}).then(() => {
					this.$root.showAlert('Archivo cargado')
					resolve(true)
				})
				.catch(reject)
			})
		},
		validateFile(file, index) {
			
			// Si tiene validaciones agregadas las aplicamos
			if (this.validations) {
				if (this.validations.size) {
					const maxSize   = this.validations.size * 1024 * 1024;
					if (file.size > maxSize) {
						this.errorMessages.push(
							`Imagen ${index + 1}: El peso del imagen no debe ser mayor ${maxSize} MB.`
						);
					}
				}

				if (this.validations.maxWidth && this.validations.maxHeight) {
					const maxWidth  = this.validations.maxWidth
					const maxHeight = this.validations.maxHeight
					const img = new Image();
					img.onload = () => {
                        if (img.width > maxWidth || img.height > maxHeight) {
                            this.errorMessages.push(
								`Imagen ${index + 1}: Las dimensiones de la imagen no deben ser mayor de ${maxWidth}x${maxHeight}.`
							);
                        }
                    };

					img.src = URL.createObjectURL(file);
				}
			}
		}
	},
	mounted(){
		this.initFilesStates()
		this.loadFiles()
	},
	watch:{
		countFiles(val){
			this.$emit('update:counter',val)
		}
	}
}
</script>

<style scoped>
.input-file{
	max-width:100% !important;
}
.box-image{
	border: 1px solid black;
	border-radius: 10px;
	font-size: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100px;
	text-align: center;
	position: relative;
	margin-bottom: 20px;
}
.box-image .download-image{
	position: absolute;
	bottom: -15px;
}
.box-image .delete-image{
	position: absolute;
	top: -5px;
	right: -5px;
}
.box-image img{
	max-height: 100%;
	max-width: 100%;
}
#files-card{
	min-height: 200px;
}
</style>
